import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../configurationService';
import { CaseService } from './case.service'
import { ObjectNames as ChannelObjectNames, MenuItems } from '../constants/constants';
import { ObjectNames } from '../../../shared/constants';
import { AppMainService } from '../../../app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CaseModuleId } from 'src/app/modules/shared/constants/modules.constant';

@Component({
  selector: 'app-case',
  templateUrl: './case.component.html',
  styleUrls: ['./case.component.scss']
})
export class CaseComponent implements OnInit {

  caseChannelConfig;
  allCaseChannels = [];

  allcaseTypeTemplateJSON;
  caseTemplatesConfig;
  allInventoryStages = [];
  allCaseTemplates = [];

  configMenuCaseItems=[];
  index=0;
  caseChannelId;
  templateTypeId;
  pipelineTypeId= null;

  sectionTypeId
  addNewElement;
  addNewField;

  //fields
  caseFieldConfig = null
  allCasefieldJSON = [];
  caseSources = [];
  casePriorities = [];

  configId : number;
    
  /** New Implementation */

  moduleId: number = CaseModuleId;

  constructor(
    private service: ConfigurationService, 
    private appMainService: AppMainService,
    public app: AppMainComponent,
    private productConfigService: CaseService
  ) { }

  ngOnInit(): void {
    
    this.getConfigurationTypes();
    this.configMenuCaseItems = [
      {
        label: MenuItems.Channel,
        icon: 'pi pi-plus',
        command: () => {
           this.addNewCaseChannel();
        }
      },
      // {
      //   label: MenuItems.Stage,
      //   icon: 'pi pi-plus',
      //   command: () => {
      //      this.addNewCaseStage();
      //   }
      // },
      {
        label: MenuItems.FieldData,
        icon: 'pi pi-plus',
        command: () => {
          this.addNewCaseFieldData();
        }
      },
    ];
   
  }

 getConfigurationTypes(){
  this.appMainService.isShowSpinner('loadTypes')
  this.productConfigService.getAllTypes().subscribe(
    types => {
      this.appMainService.isHideSpinner('loadTypes')
      this.caseChannelId = types.find(type=> type.name==ChannelObjectNames.caseConstants.Channel_Object).id;
      this.templateTypeId = types.find(type=> type.name==ChannelObjectNames.caseConstants.Channel_Template).id;
      this.pipelineTypeId = types.find(type=> type.name==ChannelObjectNames.caseConstants.Pipeline_Object).id;
      this.loadConfigurations();
    },
    err=>{
      this.appMainService.isHideSpinner('loadTypes')
    })
 }

  getIndex(event){
   this.index = event.index;
  }

  reLoadConfigurations(event){
    this.loadConfigurations();
  }

  loadConfigurations(){
    this.appMainService.isShowSpinner('loadConfiguration')
    this.service.getCaseConfigurations('case').subscribe(
      configs => {
        this.appMainService.isHideSpinner('loadConfiguration')

        //Case channel
        this.caseChannelConfig = configs.find(s => s.name == ObjectNames.CHANNEL_CASES_CONFIGURATION && s.typeId == this.caseChannelId);
        const allCaseChannelsJSON = (this.caseChannelConfig && this.caseChannelConfig.configurationDetails && this.caseChannelConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.caseChannelConfig.configurationDetails[0].configJSONValue) : []);
        this.allCaseChannels = allCaseChannelsJSON.filter(obj => obj.id > 0);
       
        //Case Template
        this.caseTemplatesConfig = configs.find(s => s.name == ObjectNames.TEMPLATE_CASES_CONFIGURATION && s.typeId == this.templateTypeId);
        this.allcaseTypeTemplateJSON = (this.caseTemplatesConfig && this.caseTemplatesConfig.configurationDetails && this.caseTemplatesConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.caseTemplatesConfig.configurationDetails[0].configJSONValue) : []);
        this.allCaseTemplates = this.allcaseTypeTemplateJSON.filter(obj => obj.id > 0);
    
        //fields data
        this.caseFieldConfig = configs.find(s => s.name == ObjectNames.FIELD_CASES_CONFIGURATION && s.typeId == this.pipelineTypeId);
        this.configId = this.caseFieldConfig != null ? JSON.parse(this.caseFieldConfig.configurationDetails && this.caseFieldConfig.configurationDetails[0].configurationId) : 0;
        this.allCasefieldJSON = this.caseFieldConfig != null ? JSON.parse(this.caseFieldConfig.configurationDetails && this.caseFieldConfig.configurationDetails[0].configJSONValue) : [];
        this.caseSources = this.allCasefieldJSON != null ? this.allCasefieldJSON.filter(s => s.fieldsType == "Source") : [];
        this.casePriorities = this.allCasefieldJSON != null ? this.allCasefieldJSON.filter(s => s.fieldsType == "Priority") : [];

        
      },
      err=>{
        this.appMainService.isHideSpinner('loadConfiguration')
      }
    );
  }
 
  addNewCaseStage(){
    this.addNewElement = {name: MenuItems.Add_Event_Stage};
    this.index = 0;
  }
  addNewCaseChannel(){
    this.addNewElement = {name: MenuItems.Add_Event_Channel};
    this.index = 0;
  }

  addNewCaseFieldData() {
    this.index = 2;
    this.addNewField = {name: MenuItems.Add_Event_Field};
  }

  cancelChannelAddUpdateModal(){
    this.addNewElement = null;
  }

}
